import { environment } from '../../environments/environment';
import { isMerchantRoleCode, resolveEffectiveRole, type RoleAwareUser } from './role-access';

/** Canonical merchant portal base URL from environment. */
export function merchantPortalUrl(): string {
  const base = (environment.merchantPortalUrl || '').replace(/\/$/, '');
  return base || 'http://localhost:4300';
}

/**
 * Redirect browser to the merchant portal (external app).
 * Optional `notice` is passed as a query param for a clear message.
 */
export function redirectToMerchantPortal(notice?: string): void {
  const url = new URL(merchantPortalUrl());
  if (notice) {
    url.searchParams.set('notice', notice);
  }
  window.location.assign(url.toString());
}

const MERCHANT_PORTAL_NOTICE =
  'Merchant roles use the Merchant Portal. Sign in there to continue.';

/** True when the user's effective (active) role is a merchant role. */
export function isMerchantOnlyUser(user: RoleAwareUser | null): boolean {
  return isMerchantRoleCode(resolveEffectiveRole(user));
}

/** Redirect merchant-role users to the merchant portal; returns true if redirected. */
export function redirectMerchantUserToPortal(user: RoleAwareUser | null): boolean {
  if (!isMerchantOnlyUser(user)) {
    return false;
  }
  redirectToMerchantPortal(MERCHANT_PORTAL_NOTICE);
  return true;
}

export { MERCHANT_PORTAL_NOTICE };
